module.exports = __webpack_public_path__ + "static/media/logo.57c9f56b.svg";